<style lang="less" scoped>
@added: #208337;
@changed: #2568db;
@deleted: #d70015;
.adminDiffControlContainer {
    padding: 10px 15px;
    .changedKey,
    .deletedKey,
    .addedKey {
        color: white;
    }
    .changedKey {
        background: @changed;
    }
    .deletedKey {
        background: @deleted;
    }
    .addedKey {
        background: @added;
    }
}
</style>
<template>
    <div class="alert alert-dark adminDiffControlContainer" v-if="adminPreview && (!inlineAdminPreview || hasChanges)">
        <template v-if="!inlineAdminPreview">
            <button type="button" class="btn btn-sm btn-outline-secondary float-right mt-1" @click="closeWindow">Close Preview</button>
            <h1 style="font-size: 20px" class="mb-2">Admin Preview</h1>
        </template>
        <div class="left" v-if="hasChanges">
            <div class="form-check form-check-inline mr-2">
                <input class="form-check-input" type="checkbox" id="ChangesCheckbox" :checked="showAdminDiff" @change="toggleAdminDiff" />
                <label class="form-check-label" for="ChangesCheckbox">Show changes</label>
            </div>
            <span v-show="showAdminDiff" style="vertical-align: top">
                <span class="addedKey badge">Added</span>
                <span class="changedKey badge">Changed</span>
                <span class="deletedKey badge">Deleted</span>
            </span>
        </div>
        <AdminSettingsDifferences :data="formData" />
        <!--
        <template v-for="child in unenabledPages">
            <AdminSettingsDifferences :data="child" />
        </template>
        -->
    </div>
</template>
<script lang="ts">
import { defineComponent, computed } from "vue";
import AdminSettingsDifferences from "../elementTemplates/AdminSettingsDifferences.3.vue";
import { usePageStore } from "../pageState/store";
interface Props {
    inlineAdminPreview?: boolean;
}
export default defineComponent({
    components: {
        AdminSettingsDifferences,
    },
    props: ["inlineAdminPreview"],
    setup(_props: Props) {
        const pageStore = usePageStore();
        //...mapState("page", {
        //    formData: state => state.formData,
        //    showAdminDiff: state => state.showAdminDiff,
        //}),
        //...mapGetters("page", ["adminPreview", "hasChanges"]),
        const toggleAdminDiff = () => {
            pageStore.toggleAdminDiff();
        };
        const closeWindow = () => {
            window.close();
        };
        return {
            toggleAdminDiff,
            closeWindow,
            adminPreview: computed(() => pageStore.adminPreview),
            showAdminDiff: computed(() => pageStore.showAdminDiff),
            hasChanges: computed(() => pageStore.hasChanges),
            formData: computed(() => pageStore.formData),
        };
    },
});
</script>
